{
  "unlockRewards": [
    {
      "reward": {
        "statToCheckAgainstForValidity": 1,
        "statToCheckAgainstForValidity_debug": "BombUpgrade",
        "amount": 1,
        "transactionalStat": 15,
        "transactionalStat_debug": "BombCount",
        "icon": "buttonBuyBomb",
        "textureName": "buttonBuyBomb",
        "malwear": 0,
        "addCumulatively": true,
        "descriptionText": "CoconutBombsInventoryDescription",
        "titleText": "CoconutBombsInventoryFormat",
        "addToUnlockNotifications": true
      },
      "rankNumber": 0
    },
    {
      "reward": {
        "statToCheckAgainstForValidity": 10,
        "statToCheckAgainstForValidity_debug": "NukeUpgrade",
        "amount": 1,
        "transactionalStat": 18,
        "transactionalStat_debug": "NukeCount",
        "icon": "the_nuke",
        "textureName": "the_nuke",
        "malwear": 0,
        "addCumulatively": true,
        "descriptionText": "TheNukeInventoryDescription",
        "titleText": "TheNukeInventoryFormat",
        "addToUnlockNotifications": true
      },
      "rankNumber": 0
    },
    {
      "reward": {
        "statToCheckAgainstForValidity": 2,
        "statToCheckAgainstForValidity_debug": "ClockMagnetUpgrade",
        "amount": 1,
        "transactionalStat": 16,
        "transactionalStat_debug": "ClockMagnetCount",
        "icon": "buttonClockMagnet",
        "textureName": "buttonClockMagnet",
        "malwear": 0,
        "addCumulatively": true,
        "descriptionText": "ClockMagnetInventoryDescription",
        "titleText": "ClockMagnetsInventoryFormat",
        "addToUnlockNotifications": true
      },
      "rankNumber": 0
    },
    {
      "reward": {
        "statToCheckAgainstForValidity": 4,
        "statToCheckAgainstForValidity_debug": "CountdownDestroyUpgrade",
        "amount": 1,
        "transactionalStat": 17,
        "transactionalStat_debug": "SkullMagnetCount",
        "icon": "buttonDestroyCountdown",
        "textureName": "buttonDestroyCountdown",
        "malwear": 0,
        "addCumulatively": true,
        "descriptionText": "SkullMagnetInventoryDescription",
        "titleText": "SkullMagnetsInventoryFormat",
        "addToUnlockNotifications": true
      },
      "rankNumber": 0
    },
    {
      "reward": {
        "statToCheckAgainstForValidity": 5,
        "statToCheckAgainstForValidity_debug": "FruitSmasherUpgrade",
        "amount": 1,
        "transactionalStat": 19,
        "transactionalStat_debug": "FruitSmasherCount",
        "icon": "button_fruitsmasher",
        "textureName": "button_fruitsmasher",
        "malwear": 0,
        "addCumulatively": true,
        "descriptionText": "FruitSmasherInventoryDescription",
        "titleText": "FruitSmasherInventoryFormat",
        "addToUnlockNotifications": true
      },
      "rankNumber": 0
    },
    {
      "reward": {
        "statToCheckAgainstForValidity": 48,
        "statToCheckAgainstForValidity_debug": "ForcefieldUpgrade",
        "amount": 1,
        "transactionalStat": 49,
        "transactionalStat_debug": "ForcefieldCount",
        "icon": "button_shield",
        "textureName": "button_shield",
        "malwear": 0,
        "addCumulatively": true,
        "descriptionText": "BarriersInventoryDescription",
        "titleText": "BarrierInventoryFormat",
        "addToUnlockNotifications": true
      },
      "rankNumber": 0
    }
  ]
}